var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "thank_you_icon",
    "data-name": "thank you icon",
    d: "M98.06-849.34l14.8-14.8-2.94-2.94L98.06-855.22l-5.985-5.985-2.94,2.94ZM101-838a20.449,20.449,0,0,1-8.19-1.654,21.206,21.206,0,0,1-6.667-4.489,21.206,21.206,0,0,1-4.489-6.667A20.448,20.448,0,0,1,80-859a20.448,20.448,0,0,1,1.654-8.19,21.206,21.206,0,0,1,4.489-6.667,21.206,21.206,0,0,1,6.667-4.489A20.449,20.449,0,0,1,101-880a20.449,20.449,0,0,1,8.19,1.654,21.206,21.206,0,0,1,6.667,4.489,21.206,21.206,0,0,1,4.489,6.667A20.448,20.448,0,0,1,122-859a20.448,20.448,0,0,1-1.654,8.19,21.206,21.206,0,0,1-4.489,6.667,21.206,21.206,0,0,1-6.667,4.489A20.449,20.449,0,0,1,101-838Z",
    transform: "translate(-80 880)",
    fill: "#34b233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.a38e7dc6d90b8b06eafd5a4165776d79.svg";
export { ForwardRef as ReactComponent };